function PageTitle({ onBack }) {
  return (
    <>
      <div className="d-flex">
        <h1 className="fw-bold fs-4">
          <div className="d-flex gap-3 mb-3 align-items-center">
            <div
              className="rounded-5 p-1 cursor-pointer"
              style={{ backgroundColor: `#E6E6E6` }}
              onClick={onBack}
            >
              <i
                class="bi bi-arrow-left-short"
                style={{ width: `1rem`, height: `1rem` }}
              ></i>
            </div>
            <span style={{ color: `#D18237` }}>Audit Logs</span>
          </div>
        </h1>
      </div>
    </>
  );
}

export default PageTitle;
